/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { SessionState } from './interfaces';
import {
  getOrganizations,
  getSettingsOrgs,
  getSettingsSuperOrg,
  getSettingsUserData,
  getUserData,
  setManagedCompanies,
} from './thunks';
import { getOrganization } from '../thunk';

const initialState: SessionState = {
  user: undefined,
  userError: false,
  shouldCompleteOnboarding: false,
  isSuperadmin: undefined,
  managedCompanies: [],
  managedCompaniesLoading: true,

  settings: {
    user: {
      first_name: '',
      last_name: '',
      email: '',
      position: '',
      phone_number: '',
    },
    orgs: [
      {
        id: 0,
        country: '',
        name: '',
        co2: {
          industry: undefined,
        },
        user_can_edit: false,
        vat_identifier: '',
      },
    ],
    super_org: {
      name: '',
      id: 0,
      user_can_edit: false,
    },
    users_permissions: [],
  },
};

export const createState = (state: Partial<SessionState>) => ({
  session: { ...initialState, ...state },
});

export const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(
        getUserData.fulfilled,
        (
          state,
          {
            payload: {
              id: userId,
              language,
              superorganization,
              organization,
              is_superuser: isSuperuser,
              email,
              available_products,
            },
          }
        ) => {
          state.user = {
            userId,
            language,
            superorganization,
            organization,
            isSuperuser,
            email,
            products: available_products,
          };
          state.userError = false;
          state.isSuperadmin = !!superorganization;
        }
      )
      .addCase(getUserData.rejected, (state) => {
        state.user = undefined;
        state.userError = true;
      })
      .addCase(getOrganization.fulfilled, (state, action) => {
        state.shouldCompleteOnboarding = !(
          action.payload.co2?.is_onboarding_completed ?? true
        );
      })
      .addCase(setManagedCompanies.fulfilled, (state, action) => {
        state.managedCompanies = action.payload;
        state.managedCompaniesLoading = false;
      })
      .addCase(getSettingsUserData.fulfilled, (state, action) => {
        state.settings.user = action.payload;
      })
      .addCase(getSettingsOrgs.fulfilled, (state, action) => {
        state.settings.orgs = action.payload;
      })
      .addCase(getSettingsSuperOrg.fulfilled, (state, action) => {
        state.settings.super_org = action.payload;
      })
      .addCase(getOrganizations.fulfilled, (state, action) => {
        // TODO: reconsider when we support superadmin for products other than CO2
        state.organizations = action.payload.filter((x) => !!x.co2);
      });
  },
});

export default sessionSlice.reducer;
